/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FilterOperations {
    Include = '0',
    Exclude = 1,
    All = 2,
}
